<script lang="ts">
	import { browser } from '$app/environment'
	import Spinner from '../loading/Spinner.svelte'
	import InViewObserver from './InViewObserver.svelte'

	interface Props {
		fetching: boolean
		hasNextPage: boolean
		onenter: () => void
	}

	let { fetching, hasNextPage, onenter }: Props = $props()
</script>

{#if fetching}
	<div class="rounded-lg h-full flex-shrink-0 flex items-center justify-center px-4 mx-auto">
		<Spinner size="sm" />
	</div>
{:else if hasNextPage && !fetching && browser}
	<InViewObserver rootMargin="300px" {onenter} enabled={true} once={false} threshold={0} />
{/if}
